import React, { ReactNode, useState } from "react";
import { Tooltip, TooltipProps, CircularProgress, Box } from "@mui/material";

type ResponsiveTooltipProps = {
  title: string | ReactNode;
  children: ReactNode;
} & TooltipProps;

const ResponsiveTooltip: React.FC<ResponsiveTooltipProps> = ({
  title,
  children,
  ...props
}) => {
  const [loading, setLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  const isImage =
    typeof title === "string" && title.match(/\.(jpeg|jpg|gif|png|svg|webp)$/);

  return (
    <Tooltip
      title={
        isImage ? (
          <Box
            position="relative"
            display="flex"
            alignItems="center"
            justifyContent="center"
            minWidth="150px"
            minHeight="100px"
          >
            {loading && !imageError && (
              <CircularProgress
                size={30}
                sx={{ position: "absolute", zIndex: 10 }}
              />
            )}
            <img
              src={title as string}
              alt="tooltip-img"
              style={{
                display: loading ? "none" : "block",
                maxWidth: "200px",
                maxHeight: "200px",
                borderRadius: "8px",
              }}
              onLoad={() => setLoading(false)}
              onError={() => {
                setLoading(false);
                setImageError(true);
              }}
            />
            {imageError && (
              <span style={{ color: "red" }}>Image failed to load</span>
            )}
          </Box>
        ) : typeof title === "string" ? (
          <span style={{ fontWeight: 600 }}>{title}</span>
        ) : (
          title
        )
      }
      arrow
      enterDelay={300}
      leaveDelay={200}
      placement={props.placement || "top"}
      componentsProps={{
        tooltip: {
          sx: isImage ? {
            // Transparent styles for image tooltips
            backgroundColor: "transparent",
            boxShadow: "none",
            padding: 0,
            "& .MuiTooltip-arrow": {
              color: "transparent",
            },
          } : {
            // Original styles for text tooltips
            backgroundColor: "#fff",
            color: "#333",
            fontSize: "0.8rem",
            fontFamily: "Arial, sans-serif",
            // padding: "14px 18px",
            borderRadius: "10px",
            // boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.25)",
            textAlign: "center",
            "& .MuiTooltip-arrow": {
              color: "#fff",
            },
          }
        },
      }}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default ResponsiveTooltip;